import { useEffect, useState } from "react";
import { Input } from "antd";
import SpeechComponent from "./Speech";
import { useFilters } from "../../data/useFilters";
import { useConfig } from "../../data/useConfig";
import {
  CustomForm,
  CustomInput,
  CustomSearchIcon,
  CustomClearIcon,
} from "./styles";

const SearchInput = ({ onSubmit = false, noTerm, showAnchor = true }) => {
  const { setSearch, setAnchor, search } = useFilters();
  const {
    anchors_key: anchorsKey,
    search_key: searchKey,
    use_voice,
    search_page_path,
    input_placeholder,
    inputWidth,
    inputHeight,
    inputBorderConfig,
    inputBorderRadius,
    inputFontSize,
    inputFontColor,
    inputBgColor,
    inputIconSize,
    inputIconColor,
    inputResponsive,
  } = useConfig();

  const inputConfigs = {
    inputWidth,
    inputHeight,
    inputBorderConfig,
    inputBorderRadius,
    inputFontSize,
    inputFontColor,
    inputBgColor,
    inputIconSize,
    inputIconColor,
    inputResponsive,
  };

  const noTermStyle = {
    width: "auto",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "60vw",
    height: "60px",
  };

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const searchInput = urlParams.get(searchKey);
  const [input, setInput] = useState(search?.input || searchInput);
  const [anchorValue, setAnchorValue] = useState();

  const onClose = (closeKey) => {
    // const url = new URL(window.location.href);
    // url.searchParams.delete(closeKey);
    // window.history.replaceState(null, null, url);
  };

  const clearSearch = () => {
    setInput("");
  };

  useEffect(() => {
    if (noTerm) return;

    setTimeout(() => {
      if (
        window.bn_config_search_page.search_term ||
        window.bn_config_search_page.anchors
      ) {
        setInput(
          decodeURIComponent(search.input) ||
            window.bn_config_search_page.search_term
        );
        setAnchorValue(window.bn_config_search_page.anchors);
        onSearch(
          null,
          window.bn_config_search_page.search_term,
          window.bn_config_search_page.anchors || ""
        );
      }
    }, 300);
  }, []);

  const onSearch = async (e, searchE = "", anchorsE = "") => {
    if (e && e !== "forceSubmit" && e.hasOwnProperty("nativeEvent")) {
      e.preventDefault();
    }

    if (onSubmit && (searchE || input) && e) {
      const encodedUrl = encodeURI(
        `/${search_page_path}?${searchKey}=${input}`
      );
      return (window.location.href = window.location.origin + encodedUrl);
    }

    if (!input || !input.length) {
      onClose(searchKey);
    }

    if (!anchorValue || !anchorValue.length) {
      onClose(anchorsKey);
    }

    if (input || searchE) {
      const newInput = { input: input ? input : searchE };
      setSearch({ ...newInput });
    }

    if (anchorsE || anchorValue) {
      setAnchor(anchorsE || anchorValue);
    }

    window.location.hash = "";
  };

  return (
    <>
      <CustomForm
        // {...inputConfigs}
        onSubmit={onSearch}
        className="bn-search__field"
        style={noTerm ? { ...noTermStyle } : { ...inputConfigs }}
      >
        {use_voice && (
          <SpeechComponent
            onText={setInput}
            onFinish={(e) => {
              setInput(e);
              if (e) {
                onSearch("forceSubmit", e);
              }
            }}
          />
        )}

        <CustomInput
          onChange={({ target: { value } }) => setInput(value)}
          value={input ? decodeURIComponent(encodeURI(input)) : ""}
          placeholder={input_placeholder}
          {...inputConfigs}
          className="bn-search__input"
        />

        <CustomClearIcon
          onClick={() => clearSearch()}
          alt="limpar"
          {...inputConfigs}
          className="bn-search__clear"
          style={{ opacity: input ? 1 : 0 }}
        />

        <CustomSearchIcon
          onClick={onSearch}
          alt="search"
          {...inputConfigs}
          className="bn-search__submit"
        />
      </CustomForm>

      {showAnchor && (
        <Input
          placeholder="Especifique uma âncora"
          className="bn-search__anchor-input"
          value={anchorValue || ""}
          onChange={({ target: { value } }) => setAnchorValue(value)}
          style={
            noTerm
              ? {
                  marginLeft: "25vw",
                  marginTop: "50px",
                  width: "50vw",
                  height: "50px",
                }
              : { width: "55%", marginLeft: "20px" }
          }
        />
      )}
    </>
  );
};

export default SearchInput;
